<template>
    <div class="editOrderWrap">
        <div class="breadBox">
            <div class="breadItem"><span>订单管理</span></div>
            <div class="breadItem"><span>订单列表</span></div>
            <div class="breadItem"><span>增加订单</span></div>
            <div class="breadItem"><span>包工包料</span></div>
        </div>
        <div class="outsideContent">
            <p class="detailBox">
                <span class="itemSpan label">发单方Id：</span>
                <span class="itemSpan text">{{fadanUserId}}</span>
                <span class="itemSpan label">发单方公司：</span>
                <span class="itemSpan text">{{companyName}}：</span>
                <span class="itemSpan label">手机号：</span>
                <span class="itemSpan text">{{user_cellphone}}</span>
                
            </p>
        </div>
        <div class="content" v-loading="isLoading">
            <!-- 表单内容 -->
            <div class="formWrap">
                <el-form :model="ruleForm" :inline="true" label-position="left" :rules="rules" ref="ruleForm"
                    label-width="190px" class="demo-ruleForm">
                    <el-form-item label="品牌" prop="orderBand" required>
                        <el-select v-model="ruleForm.orderBand" placeholder="请选择品牌">
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in brandWord"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="品质要求" prop="quantityStr" required>
                        <el-select v-model="ruleForm.quantityStr" placeholder="请选择品质要求">
                            <el-option :label="list.text" :value="list.value" v-for="(list,index) in quantityStrWord"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="大货交期" prop="orderDeliveryTime" required>
                        <el-date-picker value-format="yyyy/MM/dd" type="date" placeholder="选择日期" v-model="ruleForm.orderDeliveryTime"
                            style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <hr>
                    <el-form-item label="款式分类" prop="style1" class="block" required>
                        <el-select v-model="ruleForm.style1" placeholder="请选择款式" @change="changeStyle(1,ruleForm.style1)">
                            <el-option :label="list_style.text" :value="list_style.value" v-for="(list_style,index) in styleWord1"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="style2" class="block" required>
                        <el-select required v-model="ruleForm.style2" placeholder="请选择款式" @change="changeStyle(2,ruleForm.style2)">
                            <el-option :label="list_style.text" :value="list_style.value" v-for="(list_style,index) in styleWord2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="" prop="style3" class="block" required>
                        <el-select required v-model="ruleForm.style3" placeholder="请选择款式">
                            <el-option :label="list_style.text" :value="list_style.value" v-for="(list_style,index) in styleWord3"></el-option>
                        </el-select>
                    </el-form-item>
                    <hr>
                    <el-form-item label="样式图片" prop="name">
                        <div>
                            <div class="picUploadBox">
                                <span class="label"> <span class="errorStar">*</span> 正面全览图</span>
                                <div class="uploadBox">
                                    <div class="prevImgBox" v-for="(list_pImg,index) in positiveImgArr">
                                        <img :src="list_pImg.image_file" v-if="list_pImg.isAdd=='y'">
                                        <img :src="IMG_PREV+list_pImg.image_file" v-else>
                                        <i class="deleteIcon el-icon-delete" @click="deleteImg(index,positiveImgArr)"></i>
                                    </div>
                                    <el-upload v-if="positiveImgArr.length==0" class="avatar-uploader" :name="'files'"
                                        :data="uploadData" :action="api_app.baseUrl+'/file/uploadfilebatch'"
                                        :on-success="addImgSuccessHandle" :show-file-list="false">
                                        <div class="uploadIconBox" slot="trigger" @click="addImgClick('zheng')"><i
                                                class="el-icon-plus avatar-uploader-icon"></i></div>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="picUploadBox">
                                <span class="label">背面全览图</span>
                                <div class="uploadBox">
                                    <div class="prevImgBox" v-for="(list_pImg,index) in negativeImgArr">
                                        <img :src="list_pImg.image_file" class="avatar" v-if="list_pImg.isAdd=='y'">
                                        <img :src="IMG_PREV+list_pImg.image_file" v-else>
                                        <i class="deleteIcon el-icon-delete" @click="deleteImg(index,negativeImgArr)"></i>
                                    </div>
                                    <el-upload v-if="negativeImgArr.length==0" class="avatar-uploader" :name="'files'"
                                        :data="uploadData" :action="api_app.baseUrl+'/file/uploadfilebatch'"
                                        :on-success="addImgSuccessHandle" :show-file-list="false">
                                        <div class="uploadIconBox" slot="trigger" @click="addImgClick('fan')"><i class="el-icon-plus avatar-uploader-icon"></i></div>
                                    </el-upload>
                                </div>
                            </div>
                            <div class="picUploadBox">
                                <span class="label">细节样式图</span>
                                <div class="uploadBox">
                                    <div class="prevImgBox" v-for="(list_pImg,index) in detailsImgArr">
                                        <img :src="list_pImg.image_file" class="avatar" v-if="list_pImg.isAdd=='y'">
                                        <img :src="IMG_PREV+list_pImg.image_file" v-else>
                                        <i class="deleteIcon el-icon-delete" @click="deleteImg(index,detailsImgArr)"></i>
                                    </div>
                                    <el-upload class="avatar-uploader" :name="'files'" :data="uploadData" :action="api_app.baseUrl+'/file/uploadfilebatch'"
                                        :on-success="addImgSuccessHandle" :show-file-list="false">
                                        <div class="uploadIconBox" slot="trigger" @click="addImgClick('detail')"><i
                                                class="el-icon-plus avatar-uploader-icon"></i></div>
                                    </el-upload>
                                </div>
                            </div>
                        </div>
                        <div>
                            款式说明：<el-input v-model="ruleForm.styleDes" type="textarea"></el-input>
                        </div>
                    </el-form-item>
                    <hr>
                    <el-form-item label="颜色-尺码-数量" prop="sizeType" required>
                        <el-button @click="isShowSizeBlock=!isShowSizeBlock">
                            <i class="el-icon-caret-bottom" v-if="isShowSizeBlock">收起</i>
                            <i class="el-icon-caret-top" v-if="!isShowSizeBlock">展开</i>
                        </el-button>
                        <div v-if="isShowSizeBlock">
                            <div>
                                <el-select v-model="ruleForm.sizeType" placeholder="请选择尺码类型" @change="changeSizeType">
                                    <el-option :label="list_s.text" :value="list_s.value" v-for="(list_s,index) in sizeTypeWord"></el-option>
                                </el-select>
                            </div>
                            <div>
                                <span class="btnSpan" :class="{active:list.isSelect==1}" v-for="list in currentSizeArr"
                                    @click="toggleSelected(list,'sizeColor')"> {{list.dataName}}</span>

                            </div>
                            <ul>

                                <li class="colorGroupBox" v-for="(listSize,index) in  currentSizeGroup">
                                    <div>
                                        <i class="deleteIcon el-icon-delete" @click="deleteColorGroup(index)"></i>
                                        颜色：<el-input v-model="listSize.color" class="borderBottomInput"></el-input>小计：{{listSize.sum}}件</div>
                                    <div v-for="list2 in listSize.sizeArr">
                                        <span>尺码： {{list2.name}}</span>
                                        <el-input-number :min="0" label="描述文字" v-model="list2.number" @change="changeSizeNum(listSize)"></el-input-number>
                                        件
                                    </div>
                                </li>
                                <li class="colorGroupBox" v-if="currentSizeGroup.length>0" @click="addColorGroup">
                                    <el-button type="success">增加颜色</el-button>
                                    总数：{{ruleForm.orderQuantity}}
                                </li>
                            </ul>
                        </div>

                    </el-form-item>
                    <hr>
                    <el-form-item label="意向单价" prop="orderUnitPrice" required >
                        <el-input @change="changeOrderUnitPrice" v-model="ruleForm.orderUnitPrice" class="borderBottomInput"></el-input> 元
                    </el-form-item>
                    <el-form-item label="意向总价" prop="resource">
                        {{orderTotalPrice}}元
                    </el-form-item>
                    <hr>
                    <el-form-item label="您可提供的资料(可多选)">
                        <span class="btnSpan" :class="{active:listN.isSelect==1}" v-for="listN in ruleForm.needInfomationObj.list"
                            @click="toggleSelected(listN)">{{listN.dataName}}</span>
                        <span class="inlineSpan">其他：</span>
                        <el-input v-model="ruleForm.needInfomationObj.other"></el-input>
                    </el-form-item>
                    <hr>
                    <el-form-item label="面料信息">
                        <el-button @click="isShowFabricBlock=!isShowFabricBlock">
                            <i class="el-icon-caret-bottom" v-if="isShowFabricBlock">收起</i>
                            <i class="el-icon-caret-top" v-if="!isShowFabricBlock">展开</i>
                        </el-button>
                        <div v-if="isShowFabricBlock">
                            <ul>
                                <li class="fabricGroup" v-for="(listF,indexFabGroup) in ruleForm.fabricInformationStrObj.group">
                                    <el-button class="rightPositionButton" @click="deleteFabricGroup(indexFabGroup)" v-if="indexFabGroup>0"><i class="el-icon-delete"></i></el-button>
                                    <div>
                                        面料名称 <el-input v-model="listF.name" class="borderBottomInput" placeholder=""></el-input>
                                    </div>
                                    <div>
                                        是否指定供应商
                                        <el-radio v-model="listF.nominatedSupplier" label="1">是</el-radio>
                                        <el-radio v-model="listF.nominatedSupplier" label="0">否</el-radio>
                                    </div>
                                     <div>
                                        面料主成分
                                        <el-radio v-model="listF.fabricMainRadio" label="1">选择面料</el-radio>
                                        <el-radio v-model="listF.fabricMainRadio" label="0">自填</el-radio>
                                        <div style="padding: 10px 0 20px 60px;;">
                                             <el-select v-model="listF.fabricMainSelect" placeholder="请选择面料" v-if="listF.fabricMainRadio==1">
                                                <el-option :label="listFm.text" :value="listFm.value" v-for="(listFm,indexFm) in fabricMainWord"></el-option>
                                            </el-select>
                                            <el-input v-model="listF.fabricMainEdit" class="borderBottomInput" placeholder="自填面料" v-if="listF.fabricMainRadio==0"></el-input>
                                        </div>
                                       
                                    </div>
                                    <div>
                                        面料克重 <el-input v-model="listF.fabricGramWeight" class="borderBottomInput"></el-input>克/平方米
                                    </div>
                                    <div>
                                        是否需要复合
                                        <el-radio v-model="listF.recombination" label="1">是</el-radio>
                                        <el-radio v-model="listF.recombination" label="0">否</el-radio>
                                    </div>
                                    <div>
                                        是否需要水洗
                                        <el-radio v-model="listF.washing" label="1">是</el-radio>
                                        <el-radio v-model="listF.washing" label="0">否</el-radio>
                                    </div>
                                    <div>
                                        是否需要缩水
                                        <!-- <el-input v-model="list.shrink" class="borderBottomInput"></el-input> -->
                                        <el-radio v-model="listF.shrink" label="1">是</el-radio>
                                        <el-radio v-model="listF.shrink" label="0">否</el-radio>
                                    </div>
                                    <div>
                                        面料图片
                                        <div class="uploadBox">
                                            <div class="prevImgBox" v-for="(list_fImg,index) in listF.imageJson[0].fabricImgs">
                                                <img :src="list_fImg.image_file" class="avatar" v-if="list_fImg.isAdd=='y'">
                                                <img :src="IMG_PREV+list_fImg.image_file" v-else>
                                                <i class="deleteIcon el-icon-delete" @click="deleteImg(index,listF.imageJson[0].fabricImgs)"></i>
                                            </div>
                                            <el-upload class="avatar-uploader" :name="'files'" :data="uploadData"
                                                :action="api_app.baseUrl+'/file/uploadfilebatch'" :on-success="addImgSuccessHandle"
                                                :show-file-list="false">
                                                <div class="uploadIconBox" slot="trigger" @click="addImgClick('mianliao',listF.imageJson[0].fabricImgs)"><i
                                                        class="el-icon-plus avatar-uploader-icon"></i></div>
                                            </el-upload>
                                        </div>
                                    </div>
                                    <div>
                                        面料用料参数图片
                                        <div class="uploadBox">
                                            <div class="prevImgBox" v-for="(list_fImg,index) in listF.imageJson[0].fabricParamImgs">
                                                <img :src="list_fImg.image_file" class="avatar" v-if="list_fImg.isAdd=='y'">
                                                <img :src="IMG_PREV+list_fImg.image_file" v-else>
                                                <i class="deleteIcon el-icon-delete" @click="deleteImg(index,listF.imageJson[0].fabricParamImgs)"></i>
                                            </div>
                                            <el-upload class="avatar-uploader" :name="'files'" :data="uploadData"
                                                :action="api_app.baseUrl+'/file/uploadfilebatch'" :on-success="addImgSuccessHandle"
                                                :show-file-list="false">
                                                <div class="uploadIconBox" slot="trigger" @click="addImgClick('mianliaocanshu',listF.imageJson[0].fabricParamImgs)"><i
                                                        class="el-icon-plus avatar-uploader-icon"></i></div>
                                            </el-upload>
                                        </div>
                                    </div>
                                </li>
                            </ul>
                            <div>
                                <el-button type="primary" @click="addOneFabric">新增面料 + </el-button>
                            </div>
                            <div>
                                <div>
                                    辅料 ：
                                    <span @click="toggleSelected(listFL)" class="btnSpan" :class="{active:listFL.isSelect==1}"
                                        v-for="listFL in ruleForm.fabricInformationStrObj.excipient.list">{{listFL.dataName}}</span>
                                    <span class="inlineSpan">其他：</span>
                                    <el-input v-model="ruleForm.fabricInformationStrObj.excipient.other"></el-input>
                                </div>
                                <div>
                                    面辅料补充说明：
                                    <el-input type="textarea" v-model="ruleForm.fabricInformationStrObj.supplementInfo"></el-input>
                                </div>

                            </div>
                        </div>

                    </el-form-item>
                    <hr>
                    <el-form-item label="需要生产商制作" prop="desc">
                        <span class="btnSpan" @click="toggleSelected(list)" :class="{active:list.isSelect==1}" v-for="list in ruleForm.needProducerDoObj.list">{{list.dataName}}</span>
                        <span class="inlineSpan">其他：</span>
                        <el-input v-model="ruleForm.needProducerDoObj.other"></el-input>
                    </el-form-item>
                    <hr>
                    <hr>
                    <hr>
                    <el-form-item label="抢单截止日期" prop="orderTakingEndTime" required>
                        <el-date-picker value-format="yyyy/MM/dd HH:mm" type="datetime" placeholder="选择日期" v-model="ruleForm.orderTakingEndTime"
                            style="width: 100%;"></el-date-picker>
                    </el-form-item>
                    <hr>
                    <el-form-item label="交货方式">
                        <el-select v-model="ruleForm.deliveryMethod" placeholder="选择交货方式">
                            <el-option :label="list.text" :value="list.value" v-for="list in deliveryMethodWord"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="大货运费承担方" prop="highFreightChargeBearer" required>
                        <el-select v-model="ruleForm.highFreightChargeBearer" placeholder="请选择">
                            <el-option :label="list.text" :value="list.value" v-for="list in identifyWord"></el-option>

                        </el-select>
                    </el-form-item>
                    <hr>
                    <el-form-item label="联系方式" required>
                        <div>
                            <span class="margin10">{{choseAddressObj.address_contact_name}}</span>
                            <span class="margin10"> {{choseAddressObj.address_contact_phone}}</span>
                            <span class="margin10">{{choseAddressObj.address}}</span>
                            <el-button @click="toAddressList">获取地址列表</el-button>
                            <el-button @click="addAddress">添加新地址</el-button>
                        </div>
                         <div class="addressListsBox" v-loading="isLoadingAddress">
                            <div class="addressList" v-for="addressList in  fadanAddressLists"  :class="{active:addressList.address_id==contactMode}">
                                 <i class="el-icon-success choseAddressIcon"   @click="choseAddress(addressList)"></i>
                                 <span class="spanItem">{{addressList.address_contact_name}}</span>
                                 <span class="spanItem"> {{addressList.address_contact_phone}};</span>
                                 <span class="spanItem long">
                                    {{addressList.region_province_string}}
                                    {{addressList.region_city_string}}
                                    {{addressList.region_district_string}}
                                    {{addressList.address_string}}
                                    <span v-if="addressList.address_is_default=='y'" class="spanItem">(默认地址)</span>
                                 </span>
                                 <el-button size="mini" @click="editAddress(addressList)"><i class='el-icon-edit'></i></el-button>
                                 <el-button size="mini" @click="deleteAddress(addressList)"><i class='el-icon-delete'></i></el-button>
                            </div>
                           
                        </div>
                    </el-form-item>
                    <hr>
                    <el-form-item label="订单支付信息">
                        <el-button @click="isShowPayBlock=!isShowPayBlock">
                            <i class="el-icon-caret-bottom" v-if="isShowPayBlock">收起</i>
                            <i class="el-icon-caret-top" v-if="!isShowPayBlock">展开</i>
                        </el-button>
                        <div v-if="isShowPayBlock">
                            <div>
                                数量：{{ruleForm.orderQuantity}}件；单价：{{ruleForm.orderUnitPrice}}元；总价：{{orderTotalPrice}}元；
                            </div>
                            <div>
                                <span class="errorStar">*</span> 该意向价格是否含税：
                                <!-- <el-input v-model="ruleForm.payInfoStrObj.order_is_include_tax"></el-input> -->
                                <el-radio v-model="ruleForm.payInfoStrObj.order_is_include_tax" label="y">是</el-radio>
                                <el-radio v-model="ruleForm.payInfoStrObj.order_is_include_tax" label="n">否</el-radio>
                            </div>
                            <div>
                                <span class="errorStar">*</span>预付款:<span class="spanItem">{{orderAdvancePayment}} 元</span>
                                <el-input-number @change="computePercent_prev" @focus="focusPercent_prev" :min="0" :max="prevMoneyMax" v-model="ruleForm.payInfoStrObj.order_advance_payment_percent"></el-input-number>%
                            </div>
                            <div>
                                <span class="errorStar">*</span>交货款:<span class="spanItem">{{orderDeliveryPayment}}元</span>
                                <el-input-number  @change="computePercent_deli"  @focus="focusPercent_deli" :min="0" :max="deliMoneyMax" v-model="ruleForm.payInfoStrObj.order_delivery_payment_percent"></el-input-number>%
                            </div>
                            <div>
                                尾款/质保金：<span class="spanItem">{{tailMoney}}元</span> ({{tail_money_pecent}}%)
                                 <span class="red" v-if="tail_money_pecent<0"> 预付款和交货款之和不能大于100</span>
                            </div>
                        </div>

                    </el-form-item>
                    <hr>
                    <el-form-item label="优先推送" prop="desc">
                        <div class="userPushWrap">
                            <div class="">
                                <el-button @click="openProducerListsModal">打开生产商列表</el-button>
                            </div>
                             <div class="userPushListsBox">
                                <div class="span">当前推送的生产商:</div>
                                <ul class="producerListsBox">
                                    <li v-if="orderPushProducerLists.length==0">暂无推送</li>
                                    <li class="producerItem listBLi" v-for="(listProducer,index) in orderPushProducerLists">
                                      <span class="spanItem long">{{listProducer.company_name}}  </span>
                                      <!-- <span class="spanItem">userId：{{listProducer.user_id}}</span> -->
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </el-form-item>
                    <hr>
                    <el-form-item label="意向订单备注" prop="desc">
                        <el-input type="textarea" v-model="ruleForm.intentionalOrderRemark"></el-input>
                    </el-form-item>
                    <hr>
                    <el-form-item>
                        <el-button type="primary" @click="submitForm('ruleForm')">提交</el-button>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <addAddressModal ref="addressModal" @submitSuccessFun="getAddressLists" :type="addressModalType" :editId="currentEditAddressId" :isShow="isShowAddAddress"
            :userId="fadanUserId" @closeModal="closeAddAddressModal"></addAddressModal>
        <producerListsModal ref="producerListsModal" :hadChosedArr="orderPushProducerLists" :isShow="isShowProducerListsModal" @submitSuccessFun="chosePushProducer"   @close="isShowProducerListsModal=false"></producerListsModal>
        <el-dialog  title="发单成功!"  :visible.sync="isShowSuccessTipModal"  width="30%" center> 
            <div style="text-align: center;">
                <el-button @click="reLoadPage" type="primary">继续发单</el-button>    
                <el-button @click="toOrderList" type="success">查看订单列表</el-button>   
            </div>
        </el-dialog>

    </div>
</template>

<script>
    import {        json,        wordData,        utils    } from '@/common/common.js'
    import {        ajaxPost,        api    } from '@/common/request.js'
    import {        ajaxApp,        api_app    } from '@/common/request_app.js'
    import addAddressModal from '@/components/addAddressModal.vue'
    import producerListsModal from '@/components/producerListsModal.vue'

    export default {
        name: 'addOrder',
        data() {
             var checkUnitPrice = (rule, value, callback) => {
                if (!value) {
                  return callback(new Error('单价不能为空'));
                }
                setTimeout(() => {
                  if (isNaN(value)) {
                    callback(new Error('请输入数字值'));
                  } else {
                    if (value <= 0) {
                      callback(new Error('必须大于0'));
                    } else {
                      callback();
                    }
                  }
                }, 300);
              };
            return {
                prevMoneyMax:100,
                deliMoneyMax:100,
                isShowSuccessTipModal:false,
                producerLists:[],//所有生产商列表
                orderPushProducerLists:[],//当前已经推送的展示的
                isShowProducerListsModal:false,
                isLoadingAddress:false,
                isShowAddAddress: false, //地址组件相关
                addressModalType: '', //add edit
                currentEditAddressId: "",
                companyName:'',
                choseAddressObj: {},
                contactMode: '',
                fadanAddressLists: [],
                isLoading: false,
                uploadData: {},
                currentImgClickArr: [],
                isShowFabricBlock: true,
                isShowPayBlock: true,
                isShowSizeBlock: true,
                orderNumber: '',
                orderStatus: '',
                fadanfangInfo: {},
                imageType: '', //上传图片传的参数
                orderType: 'oem',
                fadanUserId: '',
                user_cellphone: '',
                identifyWord: [{
                    text: "发单方",
                    value: "发单方"
                }, {
                    text: "接单方",
                    value: "接单方"
                }],
                brandWord: [],
                quantityStrWord: [],
                deliveryMethodWord: [],
                faceAccessoriesWord: [],
                fabricMainWord:[],
                styleWord1: [],
                styleWord2: [],
                styleWord3: [],
                sizeTypeWord: [{
                    text: "常规尺码",
                    value: "10202"

                }, {
                    text: "裤装尺码",
                    value: "10203"

                }, {
                    text: "童装尺码",
                    value: "10204"

                }],
                regularSizeWord: [],
                pantsSizeWord: [],
                childSizeWord: [],
                currentSizeArr: [],
                currentSizeGroup: [],
                positiveImgArr: [],
                negativeImgArr: [],
                detailsImgArr: [],
                ruleForm: {
                    orderBand: '',
                    quantityStr: '',
                    orderDeliveryTime: '',
                    orderTakingEndTime: "",
                    orderUnitPrice: '',
                    orderQuantity: '',
                    highFreightChargeBearer: '',
                    deliveryMethod: '',
                    needInfomationObj: {
                        list: [],
                        other: ""
                    },
                    needProducerDoObj: {
                        list: [],
                        other: ""
                    },
                    colorSizeQuantityStrObj: {},
                    fabricInformationStrObj: {
                        group: [],
                        excipient: {
                            list: []
                        }
                    },
                    payInfoStrObj: {},
                    styleDes: '',
                    sizeType: '',
                    style1: "",
                    style2: "",
                    style3: '',
                    intentionalOrderRemark: '',
                },
                rules: {
                    orderBand: [{
                        required: true,
                        message: '请选择品牌',
                        trigger: 'blur'
                    }],
                    orderUnitPrice: [
                        { validator: checkUnitPrice, trigger: 'blur' }
                    ]
                }
            }
        },
        computed: {
            yjjToken(){
              return utils.getToken_Yjj()  
            },
            api_app() {
                return api_app
            },
            IMG_PREV() {
                return api.imgPrev
            },
            orderTotalPrice: function() { //总价
                let result=parseFloat(this.ruleForm.orderUnitPrice) * parseFloat(this.ruleForm.orderQuantity)
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                } 
            },
            tail_money_pecent: function() {
                let result=100 - this.ruleForm.payInfoStrObj.order_advance_payment_percent - this.ruleForm.payInfoStrObj
                    .order_delivery_payment_percent
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                } 
            },
            orderAdvancePayment: function() {
                let result=this.orderTotalPrice * this.ruleForm.payInfoStrObj.order_advance_payment_percent / 100
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                } 
            },
            orderDeliveryPayment: function() {
                let result=this.orderTotalPrice * this.ruleForm.payInfoStrObj.order_delivery_payment_percent / 100
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                } 
            },
            tailMoney: function() {
                let result=this.orderTotalPrice * this.tail_money_pecent / 100
                if(isNaN(result)){
                    return '-'
                }else{
                    return result.toFixed(2)
                } 
            },
        },
        components: {
            addAddressModal,producerListsModal
        },
        methods: {
            reLoadPage(){
              window.location.reload()
            },
            changeOrderUnitPrice(){
                let _this=this
                let val=this.ruleForm.orderUnitPrice
                if(!isNaN(val)&&val<0 ){
                    _this.ruleForm.orderUnitPrice=Number(val.substring(1)).toFixed(2)
                }
                if(!isNaN(val)&&val>0){
                     _this.ruleForm.orderUnitPrice=Number(val).toFixed(2)
                }
                
            },
            focusPercent_prev(){
                console.log('预付款获取焦点,设置最大为100')
                this.prevMoneyMax=100
                
            },
            focusPercent_deli(){
                console.log('交货款获取焦点,设置最大为100')
                this.deliMoneyMax=100
            },
            computePercent_prev(val){
                console.log(val,'change预付款')
                if(val==100){
                    this.ruleForm.payInfoStrObj.order_delivery_payment_percent=0 
                }else{
                    this.prevMoneyMax=100-this.ruleForm.payInfoStrObj.order_delivery_payment_percent
                    this.deliMoneyMax=100-val
                }
                
            },
            computePercent_deli(val){
                console.log(val,'change交货款')
                if(val==100){
                    this.ruleForm.payInfoStrObj.order_advance_payment_percent=0 
                }else{
                    this.deliMoneyMax=100-this.ruleForm.payInfoStrObj.order_advance_payment_percent
                    this.prevMoneyMax=100-val
                }
            },
            toOrderList(){
                 utils.clearSearchObjSession()
                this.$router.push('/orderList')
            },
            chosePushProducer(producerLists){
                let _this=this
                console.log("modal里面选择完成了，现在开始重置页面的数据")
                this.orderPushProducerLists=[]
                producerLists.forEach(function(item,index){
                    if(item.isChosed==1){
                        let buffer={}
                        buffer.user_id=item.user_id
                        buffer.company_name=item.company_name
                        _this.orderPushProducerLists.push(buffer)
                    }
                })
            },
            openProducerListsModal(){
                this.isShowProducerListsModal=true
                this.$refs.producerListsModal.resetProducerLists()
            },
            deleteAddress(list){
                let _this = this
                let arg = {
                	addressId: list.address_id,
                }
                ajaxApp('/yijiajiaUserAddress/delUserAddress', arg).then(function(res) {
                     _this.$message({
                        message: res.errorMsg,
                        type: 'success',
                        duration: 1000
                    });
                    _this.getAddressLists()
                }, function(res) {})
                
            },
            deleteFabricGroup(index){
                this.ruleForm.fabricInformationStrObj.group.splice(index,1)
            },
            closeAddAddressModal() {
                console.log(6666666)
                this.isShowAddAddress = false
            },
            addAddress() {
                this.isShowAddAddress = true
                this.addressModalType = 'add'
                this.currentEditAddressId = ""
                this.$refs.addressModal.initAddressModal();
            },
            editAddress(list) {
                console.log(list)
                this.isShowAddAddress = true
                this.addressModalType = 'edit'
                this.currentEditAddressId = list.address_id
                this.$refs.addressModal.getDetailById(this.currentEditAddressId);

            },
            choseAddress(list) {
                this.contactMode = list.address_id
                this.choseAddressObj = {
                    address: list.region_province_string + list.region_city_string + list.region_district_string +
                        list.address_string,
                    address_contact_name: list.address_contact_name,
                    address_contact_phone: list.address_contact_phone
                }
            },
            toAddressList() {
                this.getAddressLists()
            },
            getAddressLists() {
                let _this = this
                let arg = {
                    userId: _this.fadanUserId
                }
                this.isLoadingAddress=true
                ajaxApp('/yijiajiaUserAddress/requestUserAddressList', arg).then(function(res) {
                    setTimeout(function(){
                        _this.isLoadingAddress=false
                    },500)
                    if (res.errorCode == 200) {
                        _this.fadanAddressLists = JSON.parse(JSON.stringify(res.data))
                    }

                }, function(res) {})
            },
            addOneFabric() {
                //fabricInformationStrObj 
                let buffer = {
                    name: "",
                    nominatedSupplier:"",
                    fabricMainRadio: "",
                    fabricMainEdit: "", //fabricMain
                    fabricMainSelect: "",  //fabricMain
                    fabricGramWeight:"",
                    recombination: "",
                    shrink: "",
                    washing: "",
                    imageJson: [{
                        fabricImgs: [],
                        fabricParamImgs: []
                    }],
                }
                this.ruleForm.fabricInformationStrObj.group.push(buffer)
            },
            choseBrandUserId() {
                this.fadanUserId=this.$route.params.userId
                this.companyName=this.$route.params.companyName
                this.user_cellphone=this.$route.params.user_cellphone
                //获取选项
                this.getBrandData()
            },
            deleteImg(index, arr) {
                console.log(index)
                console.log(arr)
                arr.splice(index, 1)
            },
            addImgClick(type, arr) {
                console.log(type, '当前点击的类型')
                let token=this.yjjToken
                if (type == 'zheng') {
                    this.imageType = 31101
                    this.uploadData = {
                        imageType: this.imageType,
                        imageUserId: this.fadanUserId,
                        token: token,
                    }
                }
                if (type == 'fan') {
                    this.imageType = 31201
                    this.uploadData = {
                        imageType: this.imageType,
                        imageUserId: this.fadanUserId,
                        token: token,
                    }
                }
                if (type == 'detail') {
                    this.imageType = 31301
                    this.uploadData = {
                        imageType: this.imageType,
                        imageUserId: this.fadanUserId,
                        token: token,
                    }
                }
                if (type == 'mianliao') {
                    this.imageType = 32101
                    this.currentImgClickArr = arr
                    this.uploadData = {
                        imageType: this.imageType,
                        imageUserId: this.fadanUserId,
                        token: token,
                    }
                }
                if (type == 'mianliaocanshu') {
                    this.imageType = 32201
                    this.currentImgClickArr = arr
                    this.uploadData = {
                        imageType: this.imageType,
                        imageUserId: this.fadanUserId,
                        token: token,
                    }
                }


            },
            addImgSuccessHandle(res, file) {
                let _this = this
                if (res.errorCode == 200) {
                    let imageUrl = URL.createObjectURL(file.raw);
                    let resIdStr = res.data
                    let resIdArr = resIdStr.split(",")
                    _this.$message({
                        message: "上传成功",
                        type: 'success',
                        duration: 1000
                    });
                    let buffer = {
                        image_file: imageUrl,
                        imgIdArr: resIdArr,
                        isAdd: 'y'
                    }

                    if (_this.imageType == 31101) {
                        _this.positiveImgArr.push(buffer)
                    }
                    if (_this.imageType == 31201) {
                        _this.negativeImgArr.push(buffer)
                    }
                    if (_this.imageType == 31301) {
                        _this.detailsImgArr.push(buffer)
                    }
                    if (_this.imageType == 32101) {
                        _this.currentImgClickArr.push(buffer)
                    }
                    if (_this.imageType == 32201) {
                        _this.currentImgClickArr.push(buffer)
                    }


                } else {
                    _this.$message({
                        message: "上传失败",
                        type: 'error',
                        duration: 1000
                    });
                }
            },
            changeSizeNum(list) {
                let _this = this
                console.log(list)
                list.sum = 0
                list.sizeArr.forEach(function(item, index) {
                    list.sum += parseInt(item.number)
                })
                //总数量
                _this.ruleForm.orderQuantity = 0
                _this.currentSizeGroup.forEach(function(item, index) {
                    _this.ruleForm.orderQuantity += item.sum
                })

            },
            deleteColorGroup(index) {
                this.currentSizeGroup.splice(index, 1)
            },
            addColorGroup() {
                let childArr = []
                this.currentSizeArr.forEach(function(item, index) {
                    if (item.isSelect == 1) {
                        let temp = {
                            name: item.dataName,
                            number: 0
                        }
                        childArr.push(temp)
                    }
                })
                if (childArr.length > 0) {
                    let buffer = {
                        color: "",
                        fold: false,
                        sum: 0,
                        sizeArr: childArr
                    }
                    this.currentSizeGroup.push(buffer)
                }

                console.log(childArr, ' childArr')
                console.log(this.currentSizeGroup, ' this.currentSizeGroup')
            },
            toggleSelected(list, arg) { //点击按钮active
                list.isSelect = list.isSelect == 1 ? 0 : 1
                if (arg == 'sizeColor') {
                    this.currentSizeGroup = []
                    this.addColorGroup()
                }
            },
            changeSizeType() {
                if (this.ruleForm.sizeType == 10202) {
                    this.currentSizeArr = this.regularSizeWord
                    console.log(this.currentSizeArr)
                }
                if (this.ruleForm.sizeType == 10203) {
                    this.currentSizeArr = this.pantsSizeWord
                }
                if (this.ruleForm.sizeType == 10204) {
                    this.currentSizeArr = this.childSizeWord
                }
                this.currentSizeGroup = []

            },
            changeStyle(num, value) {
                let _this = this
                let arg = {
                    parentId: value
                }
                ajaxApp('/yijiajiaDataCategory/categoryInfo', arg).then(function(res) {
                    console.log(num, res.data)
                    if (res.errorCode === 200) {
                        if (num == 'default') {
                            _this.styleWord1 = res.data.map(function(item, index) {
                                return {
                                    text: item.category_name,
                                    value: item.category_id,
                                }
                            })
                            _this.styleWord2 = []
                            _this.styleWord3 = []
                            _this.ruleForm.style1 = ''
                            _this.ruleForm.style2 = ''
                            _this.ruleForm.style3 = ''
                        }
                        if (num == 1) {

                            _this.styleWord2 = res.data.map(function(item, index) {
                                return {
                                    text: item.category_name,
                                    value: item.category_id,
                                }
                            })
                            _this.styleWord3 = []
                            _this.ruleForm.style2 = ''
                            _this.ruleForm.style3 = ''
                        }
                        if (num == 2) {
                            _this.styleWord3 = res.data.map(function(item, index) {
                                return {
                                    text: item.category_name,
                                    value: item.category_id,
                                }
                            })
                            _this.ruleForm.style3 = ''
                        }

                    }
                }, function(res) {

                })
            },
            // 获取品牌数据
            getBrandData() {
                let _this = this
                let arg = {
                    userId: this.fadanUserId,
                }
                ajaxApp('/yijiajiaUserAuth/showUserAuthBrand', arg).then(function(res) {
                    if (res.errorCode === 200) {
                        _this.brandWord = []
                        let arr = res.data.companyBrand && res.data.companyBrand.split(',');
                        arr.forEach(function(item, index) {
                            let buffer = {
                                text: item,
                                value: item,
                            }
                            _this.brandWord.push(buffer)
                        })
                        console.log(_this.brandWord, '品牌')

                    }
                }, function(res) {

                })

            },

            // 获取初始数据
            getCategoryData() {
                let _this = this
                let arg = {
                    types: '10201,10202,10203,10204,10205,10206,10230,10231,10232,10233,10234,10235,10236,10237'
                }
                ajaxApp('/yijiajiaDataCategory/getDatasource', arg).then(function(res) {
                    if (res.errorCode == 200) {
                        //获取品质
                        _this.quantityStrWord = res.data.quantityStr.list.map((item, index) => {
                            return {
                                text: item.dataName,
                                value: item.dataName
                            }
                        })
                        //获取尺码
                        _this.regularSizeWord = res.data.regularSize.list
                        _this.pantsSizeWord = res.data.pantsSize.list
                        _this.childSizeWord = res.data.childSize.list
                        //获取deliveryMethodWord
                        _this.deliveryMethodWord = res.data.deliveryMethod.list.map((item, index) => {
                            return {
                                label: item.dataName,
                                value: item.dataName,
                            }
                        })
                        //获取面辅料提供情况
                        _this.faceAccessoriesWord = res.data.faceAccessories.list.map((item, index) => {
                            return {
                                label: item.dataName,
                                value: item.dataName,
                            }
                        })
                        //获取面料信息：羊毛，亚麻等
                         _this.fabricMainWord=res.data.mainComponentFabric.list.map((item,index) =>{
                             return {
                                 label: item.dataName,
                                 value: item.dataName,
                             }
                         })
                         
                        _this.ruleForm.needInfomationObj = res.data.needInfomation
                        _this.ruleForm.needProducerDoObj = res.data.needProducerDo

                        _this.ruleForm.fabricInformationStrObj.excipient = res.data.excipient
                        
                    }
                }, function(res) {

                })

            },
            getStrFromKey(key, wordArr) {
                let result = ""
                wordArr.forEach(function(item, index) {
                    if (item.value == key) {
                        result = item.text
                    }
                })
                return result
            },
            getStrFromStyleword(num, key) {
                let result = ""
                if (isNaN(parseFloat(key))) {
                    result = key
                } else {
                    if (num == 1) {
                        this.styleWord1.forEach(function(item, index) {
                            if (item.value == key) {
                                result = item.text
                            }
                        })
                    }
                    if (num == 2) {
                        this.styleWord2.forEach(function(item, index) {
                            if (item.value == key) {
                                result = item.text
                            }
                        })
                    }
                    if (num == 3) {
                        this.styleWord3.forEach(function(item, index) {
                            if (item.value == key) {
                                result = item.text
                            }
                        })
                    }
                }
                return result
            },
            mapArrImgId(arr) {

                if (arr) {
                    let imageArr = []
                    arr.forEach(function(item, index) {
                        if (item.isAdd == 'y') {
                            item.imgIdArr.forEach(function(item2, index2) {
                                imageArr.push(JSON.parse(item2))
                            })
                        } else {
                            let obj = {
                                imgId: item.imgId
                            }
                            imageArr.push(obj)
                        }
                    })
                    return imageArr

                } else {
                    return null
                }
            },
            concatImgArr() {
                let _this = this
                let result = []
                for (var i = 0; i < arguments.length; i++) {
                    var item = arguments[i]
                    if (item && item.length > 0) {
                        result = result.concat(_this.mapArrImgId(item))
                    }
                }
                return result

            },
            submitForm(formName) {
                let _this = this
                this.$refs[formName].validate((valid) => {
                    console.log(_this.ruleForm, "ruleForm")
                    if (valid) {
                        let sizeStyleText = this.getStrFromKey(this.ruleForm.sizeType, this.sizeTypeWord)
                        let colorSizeObj = {
                            "orderQuantity": _this.ruleForm.orderQuantity,
                            "groupQuantity": this.currentSizeGroup.length,
                            "group": this.currentSizeGroup,
                            "selectSize": {
                                "label": sizeStyleText,
                                "value": this.ruleForm.sizeType,
                                "list": this.currentSizeArr
                            }
                        }
                        //面辅料图片组装
                        let fabricInformationObj = JSON.parse(JSON.stringify(this.ruleForm.fabricInformationStrObj))
                        fabricInformationObj.group.forEach(function(item, index) {
                            console.log(item, 'group')
                            //组装图片
                            item.imageJson = _this.concatImgArr(item.imageJson[0].fabricImgs, _this.mapArrImgId(
                                item.imageJson[0].fabricParamImgs))
                            //组装主面料
                            if(item.fabricMainRadio==1){//1是选择，0是自填
                                item.fabricMain=item.fabricMainSelect
                            }
                            if(item.fabricMainRadio==0){
                                item.fabricMain=item.fabricMainEdit
                            }
                           
                        })
                        //图片组装：正面，背面，详情  positiveImgArr:[],  negativeImgArr:[],  detailsImgArr:[],
                        let imageArr = []
                        imageArr = _this.concatImgArr(this.positiveImgArr, this.negativeImgArr, this.detailsImgArr)
                        let needInfomationObj = this.ruleForm.needInfomationObj
                        let needProducerDoObj = this.ruleForm.needProducerDoObj
                        let orderPayInfoObj = {
                            "orderIsIncludeTax": _this.ruleForm.payInfoStrObj.order_is_include_tax,
                            "orderAdvancePaymentPercent": _this.ruleForm.payInfoStrObj.order_advance_payment_percent,
                            "orderDeliveryPaymentPercent": _this.ruleForm.payInfoStrObj.order_delivery_payment_percent
                        }
                        let styleStr = _this.getStrFromStyleword(1, _this.ruleForm.style1) + '-' + _this.getStrFromStyleword(
                            2, _this.ruleForm.style2) + '-' + _this.getStrFromStyleword(3, _this.ruleForm.style3)
                        //验证
                        if (_this.positiveImgArr.length == 0) {
                            this.$message({
                                message: "正面全览照片没有上传",
                                type: 'error',
                                duration: 1000
                            });
                            return false
                        }
                        if (!colorSizeObj.groupQuantity > 0) {
                            this.$message({
                                message: "至少选择一个尺码",
                                type: 'error',
                                duration: 1000
                            });
                            return false
                        }
                        let isVerifySizeColor = true
                        _this.currentSizeGroup.forEach(function(item, index) {
                            let orderIndex = index + 1
                            if (!item.color) {
                                isVerifySizeColor = false
                                _this.$message({
                                    message: '第' + orderIndex + "组" + "未填写颜色",
                                    type: 'error',
                                    duration: 1000
                                });
                                return false
                            }
                            if (!item.sum > 0) {
                                isVerifySizeColor = false
                                _this.$message({
                                    message: '第' + orderIndex + "组" + "未选择数量",
                                    type: 'error',
                                    duration: 1000
                                });
                                return false
                            }
                        })
                        if (!isVerifySizeColor) {
                            return false
                        }
                        if (!orderPayInfoObj.orderIsIncludeTax) {
                            _this.$message({
                                message: "未选择支付信息是否含税",
                                type: 'error',
                                duration: 1000
                            });
                            return false
                        }
                        if (!(parseInt(_this.tail_money_pecent) + parseInt(_this.ruleForm.payInfoStrObj.order_advance_payment_percent) +
                                parseInt(_this.ruleForm.payInfoStrObj.order_delivery_payment_percent) == 100)) {
                            _this.$message({
                                message: "未正确选择付款的百分比",
                                type: 'error',
                                duration: 1000
                            });
                            return false
                        }
                        if(_this.tail_money_pecent<0){
                             _this.$message({message: "预付款与交货款比例不能大于100",type: 'error',duration: 1500});
                            return false
                        }
                        if(!_this.contactMode){
                             _this.$message({
                                message: "未选择地址",
                                type: 'error',
                                duration: 1000
                            });
                            return false
                        }

                        //推送商家
                       let orderPushUserIdStr=''
                       if(_this.orderPushProducerLists.length>0){
                           let idArr=[]
                           _this.orderPushProducerLists.forEach(function(item,index){
                               let bufferId=item.user_id
                               idArr.push(bufferId)
                           })
                           orderPushUserIdStr=idArr.join(",")
                       }
                       if(!confirm("确认提交吗？")){
                           return false
                       }
                       console.log("表单参数验证通过")
                       _this.isloading=true

                        //组装参数
                        let args = {
                            colorSizeQuantityStr: JSON.stringify(colorSizeObj),
                            contactMode: _this.contactMode,
                            deliveryMethod: _this.ruleForm.deliveryMethod,
                            fabricInformation: JSON.stringify(fabricInformationObj),
                            highFreightChargeBearer: _this.ruleForm.highFreightChargeBearer,
                            imageJson: JSON.stringify(imageArr),
                            intentionalOrderRemark: _this.ruleForm.intentionalOrderRemark,
                            needInfomation: JSON.stringify(needInfomationObj),
                            needProducerDo: JSON.stringify(needProducerDoObj),
                            orderBand: _this.ruleForm.orderBand,
                            orderDeliveryTime: _this.ruleForm.orderDeliveryTime,
                            orderIsDraft: "y",
                            orderPayInfo: JSON.stringify(orderPayInfoObj),
                            orderPushUserId: orderPushUserIdStr,//1,311
                            orderStyleMemo: styleStr,
                            orderTakingEndTime: _this.ruleForm.orderTakingEndTime,
                            orderType: this.orderType,
                            orderUnitPrice: _this.ruleForm.orderUnitPrice,
                            phone: _this.user_cellphone,
                            quantityStr: _this.ruleForm.quantityStr,
                            styleDes: _this.ruleForm.styleDes,
                            userId: _this.fadanUserId
                        }
                        console.log(args, "args")
                        _this.isLoading = true
                        ajaxApp('/yijiajiaOrder/publishOrder', args).then(function(res) {
                            _this.isLoading = false
                            if (res.errorCode == 200) {
                                _this.isShowSuccessTipModal=true
                            } else {
                                _this.$message({
                                    message: res.errorMsg,
                                    type: 'error',
                                    duration: 1000
                                });

                            }
                        }, function(res) {
                            _this.isLoading = false
                            _this.$message({
                                message: res.errorMsg,
                                type: 'error',
                                duration: 1000
                            });
                        })
                    } else {
                        console.log('error submit!!');
                        alert("表单没有填写完整或格式不正确")
                        return false;
                    }
                });
            },
        },
        mounted() {
            let _this = this
            _this.choseBrandUserId()
            _this.getCategoryData()
            _this.changeStyle('default', 0)
            _this.addOneFabric()

        }
    }
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/pages/order/addOem.vue